<template>
  <v-container>
    <v-form v-model="valid" ref="busEntity">
      <v-row>
        <v-col cols="12" md="6">
          <label
            >{{ $t("entity_type_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="addProfilePayload.entity_type"
            :items="entityType_options"
            :rules="EntityRules.entity_typeRules"
            item-text="name"
            item-value="id"
            :placeholder="$t('entity_type_placeholder')"
            outlined
            dense
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label v-if="addProfilePayload.entity_type == '9'"
            >{{ $t("name_of_the_charities")
            }}<span style="color: #f00">*</span></label
          >
          <label v-else
            >{{ $t("name_of_the_company_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            dense
            :placeholder="
              addProfilePayload.entity_type == '9'
                ? $t('name_of_the_charities')
                : $t('name_of_the_company_placeholder')
            "
            outlined
            required
            v-model="addProfilePayload.business_name"
            :rules="EntityRules.CompanyNameRules"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("registration_no_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            :placeholder="$t('registration_no_placeholder')"
            dense
            outlined
            required
            v-model="addProfilePayload.registration_number"
            :rules="EntityRules.RegistrationNoRules"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <label
            >{{ $t("date_of_incorporation_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            :placeholder="$t('date_of_incorporation_placeholder')"
            dense
            type="date"
            outlined
            :max="new Date().toJSON().slice(0, 10)"
            required
            v-model="addProfilePayload.dob"
            :rules="EntityRules.DoiRules"
            @change="ValidateDateofIncop(addProfilePayload.dob)"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <label
            >{{ $t("source_of_funds_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="addProfilePayload.source_of_fund_code"
            :items="source_options"
            item-text="name"
            item-value="id"
            :rules="EntityRules.SOFrules"
            :placeholder="$t('source_of_funds_placeholder')"
            outlined
            dense
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("nature_of_business_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="addProfilePayload.nature_of_business"
            :rules="EntityRules.natureOfBusinessErrors"
            :items="natureofbusList"
            item-text="name"
            item-value="id"
            :placeholder="$t('nature_of_business_placeholder')"
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label>{{ $t("website_business") }}</label>
          <v-text-field
            v-model="addProfilePayload.website"
            :placeholder="$t('website_placeholder')"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("contactNumber") }}<span style="color: #f00">*</span></label
          >
          <vue-phone-number-input
            default-country-code="MY"
            @update="onChangeNumber"
            :error="contactNumberError"
            v-model="addProfilePayload.phone_number"
            :rules="EntityRules.contactNoErrors"
            class=""
          />
          <span v-if="contactNumberError" style="color: #ff5252; font-size: 12px">
            {{ $t("contactNoErrors") }}
          </span>
        </v-col>
        <v-col cols="12" md="6">
          <label>{{ $t("average_annual_turnover_business") }}</label>
          <v-autocomplete
            v-model="addProfilePayload.salary_range"
            :items="annualTurnoverOptions"
            item-text="name"
            item-value="id"
            :placeholder="$t('average_annual_turnover_placeholder')"
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("businessEmail") }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            v-model="addProfilePayload.business_email"
            :rules="EntityRules.emailValidations"
            :placeholder="$t('email_business')"
            dense
            outlined
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <label
            >{{ $t("corporate_address_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            :placeholder="$t('corporate_address_placeholder')"
            outlined
            required
            dense
            v-model="addressInfo.mailing_address"
            :rules="EntityRules.corporateAddErrors"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("country_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            :placeholder="$t('select_country_placeholder')"
            :items="country_options"
            v-model="addressInfo.mailing_country"
            item-text="name"
            item-value="id"
            :rules="EntityRules.countryErrors"
            @input="onChangeCounty($event)"
            outlined
            required
            dense
            disabled
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("state_business") }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="addressInfo.mailing_state"
            :items="state_options"
            :placeholder="$t('select_state_placeholder')"
            item-text="name"
            item-value="id"
            outlined
            required
            :rules="EntityRules.mailingStateErrors"
            @input="onChangeState($event)"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label>{{ $t("city") }}<span style="color: #f00">*</span></label>
          <v-autocomplete
            v-if="haveCities"
            v-model="addressInfo.mailing_city"
            :placeholder="$t('select_city_placeholder')"
            :items="city_options"
            item-text="txt"
            item-value="val"
            :rules="EntityRules.mailingCityErrors"
            outlined
            required
            dense
          >
          </v-autocomplete>
          <v-text-field
            v-else
            v-model="addressInfo.mailing_city"
            :placeholder="$t('enter_city')"
            :rules="EntityRules.citytextErrors"
            outlined
            required
            dense
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("postalCode") }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="addressInfo.mailing_postal_code"
            :items="postalCodeslist"
            :rules="EntityRules.postalCodeErrors"
            :placeholder="$t('postal_code_placeholder')"
            outlined
            dense
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <!-- <label>{{ $t("mailingAddress") }}</label> -->
        <v-col cols="12" class="pb-0">
          <v-checkbox
            v-model="
              addProfilePayload.is_mailing_address_same_as_business_address
            "
            :label="$t('sameAsBusinessAddress')"
            @change="onSameAddressChange"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("business_address")
            }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            :placeholder="$t('Enter Business Address')"
            outlined
            required
            dense
            v-model="businessAddress.address"
            :rules="EntityRules.corporateAddErrors"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("country_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            :placeholder="$t('select_country_placeholder')"
            :items="country_options"
            v-model="businessAddress.country_code"
            item-text="name"
            item-value="id"
            :rules="EntityRules.countryErrors"
            @change="onChangeBusinessCountry"
            outlined
            required
            dense
            :disabled="addProfilePayload.is_mailing_address_same_as_business_address"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("state_business") }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="businessAddress.state_code"
            :items="businessStateOptions"
            :placeholder="$t('select_state_placeholder')"
            item-text="name"
            item-value="id"
            outlined
            required
            :rules="EntityRules.stateErrors"
            @input="onChangemailingState($event)"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label>{{ $t("city") }}<span style="color: #f00">*</span></label>
          <v-autocomplete
            v-if="haveBusCities"
            v-model="businessAddress.city_code"
            :placeholder="$t('select_city_placeholder')"
            :items="maling_city_options"
            item-text="txt"
            item-value="val"
            :rules="EntityRules.cityErrors"
            outlined
            required
            dense
          >
          </v-autocomplete>
          <v-text-field
            v-else
            v-model="businessAddress.city_code"
            :placeholder="$t('enter_city')"
            :rules="EntityRules.citytextErrors"
            outlined
            required
            dense
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("postalCode") }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-if="businessAddress.country_code === 'MYS'"
            v-model="businessAddress.zip_code"
            :items="postalCodeslist"
            :rules="EntityRules.postalCodeErrors"
            :placeholder="$t('postal_code_placeholder')"
            outlined
            dense
          ></v-autocomplete>
          <v-text-field
            v-else
            v-model="businessAddress.zip_code"
            :rules="EntityRules.postalCodeErrors"
            :placeholder="$t('postal_code_placeholder')"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-btn
            v-if="is_update"
            color="primary"
            class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
            @click="updateEntityinfo"
            >{{ $t("Update") }}
          </v-btn>
          <v-btn
            v-else
            color="primary"
            class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
            @click="onClickNext"
            >{{ $t("Save") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <loading
      :active="loader"
      :is-full-page="true"
      :opacity="0.9"
      color="#ff6b00"
    />
  </v-container>
</template>

<script>
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Loading from "vue-loading-overlay";
import { entityTypes } from "../../utils/BusDocuments";
import commonService from "@/services/AgentCommonService/commonService.js";
import AgentService from "@/services/agentService/AgentService";
import alerts from "@/mixins/alerts";
import { i18n as $ } from "../../locale/index";
export default {
  mixins: [alerts],
  data: () => ({
    isValidNumber: false,
    isContactTouched: false,
    valid: true,
    is_update: false,
    combinedData: {},
    loader: false,
    entityType_options: [],
    entityTypes: entityTypes(),
    source_options: [],
    doistate: false,
    source_of_funds: "",
    addProfilePayload: {
      entity_type: "",
      business_name: "",
      registration_number: "",
      nature_of_business: "",
      website: "",
      business_email: "",
      street_number: "",
      mailing_address: "",
      mailing_country: "",
      mailing_state: "",
      mailing_city: "",
      mailing_postal_code: "",
      is_mailing_address_same_as_business_address: false,
      dob: null,
      source_of_fund_code: "",
      phone_number: "",
      salary_range: "",
      address: "",
      country_code: "",
      state_code: "",
      city_code: "",
      zip_code: "",
    },
    country_options: [],
    state_options: [],
    businessStateOptions: [],
    city_options: [],
    maling_city_options: [],
    isSubmitted: false,
    addressInfo: {
      mailing_address: "",
      mailing_country: "",
      mailing_state: "",
      mailing_city: "",
      mailing_postal_code: "",
    },
    businessAddress: {
      street_number: "",
      address: "",
      country_code: "",
      state_code: "",
      city_code: "",
      zip_code: "",
    },
    EntityRules: {
      entity_typeRules: [(v) => !!v || $.t("entity_typeRules")],
      CompanyNameRules: [(v) => !!v || $.t("CompanyNameRules")],
      RegistrationNoRules: [(v) => !!v || $.t("RegistrationNoRules")],
      DoiRules: [(v) => !!v || $.t("DoiRules")],
      SOFrules: [(v) => !!v || $.t("SOFrules")],
      natureOfBusinessErrors: [(v) => !!v || $.t("natureOfBusinessErrors")],
      contactNoErrors: [(v) => !!v || $.t("contactNoErrors")],
      emailValidations: [
        (v) => !!v || $.t("email_errors"),
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          $.t("invalid_email"),
      ],
      turnoverErrors: [(v) => !!v || $.t("turnoverErrors")],
      corporateAddErrors: [
        (v) => !!v || $.t("address_req"),
        (v) => v.length < 98 || $.t("address_minlength"),
      ],
      countryErrors: [(v) => !!v || $.t("country_field_required")],
      mailingStateErrors: [(v) => !!v || $.t("state_field_is_required")],
      mailingCityErrors: [(v) => !!v || $.t("city_placeholder_beneficary")],
      stateErrors: [(v) => !!v || $.t("state_field_is_required")],
      cityErrors: [(v) => !!v || $.t("city_placeholder_beneficary")],
      citytextErrors: [(v) => !!v || $.t("city_placeholder_beneficary")],
      postalCodeErrors: [
        (v) => !!v || $.t("postalcode_placeholder_beneficary"),
      ],
    },
    cityValue: "",
    haveCities: true,
    cityBusValue: "",
    haveBusCities: true,
    postalCodeslist: [],
    natureofbusList: [],
    annualTurnoverOptions: [],
  }),
  name: "BasicDetails",

  components: {
    VuePhoneNumberInput,
    Loading,
  },

  watch: {
    "addProfilePayload.entity_type"(val) {
      let entity_type = this.entityTypes.entityTypes.find(
        (type) => type.value_code === val
      );
      let entity_name = entity_type?.value;
      if (entity_name) {
        this.$emit("selctedEntitytype", entity_name);
      }
    },
    "addProfilePayload.dob"(val) {
      const incorpDate = "2017-01-31";
      console.log(incorpDate);
      console.log(
        "addProfilePayload.entity_type",
        this.addProfilePayload.entity_type
      );
      console.log("time", val);
      if (this.addProfilePayload.entity_type === "1" && val > incorpDate) {
        this.$emit("isHideform", "form_9");
      } else if (
        this.addProfilePayload.entity_type === "1" &&
        val < incorpDate
      ) {
        this.$emit("isHideform", "form_51");
      }
    },
    addressInfo: {
      deep: true,
      handler() {
        if (this.addProfilePayload.is_mailing_address_same_as_business_address) {
          this.copyRegisteredAddress();
        }
      },
    },
  },
  computed: {
    contactNumberError() {
      const hasPhoneNumber = Boolean(this.addProfilePayload.phone_number);
      return (
        (this.isContactTouched && !hasPhoneNumber) ||
        (hasPhoneNumber && !this.isValidNumber)
      );
    },
  },
  created() {
    this.getEntityType();
    this.addProfilePayload.entity_type = "1";
    this.getCountryList();
    this.getPostalCodes();
    const country_Info = JSON.parse(sessionStorage.getItem("partner_country"));
    this.addressInfo.mailing_country = country_Info.iso_alpha3;
    this.businessAddress.country_code = country_Info.iso_alpha3;
    this.getSourceFunds();
    this.getAnnualTurnoverRanges();
    this.getnatureOfBusiness();
    if (this.$route.query.login_id) {
      this.getentitydetails();
    } else {
      this.onChangeCounty(country_Info.iso_alpha3);
      this.loadBusinessStates(country_Info.iso_alpha3);
    }
  },
  methods: {
    hasValidPhoneNumber(value) {
      return /^\d{7,15}$/.test(String(value || "").replace(/\D/g, ""));
    },
    getDropdownValue(value) {
      if (!value) return "";
      return value.value_code || value.id || value;
    },
    getCountryValue(country) {
      if (!country) return "MYS";
      return country.iso_alpha3 || country.iso3 || country;
    },
    getStateValue(state) {
      if (!state) return "";
      return state.state_code || state;
    },
    getCityValue(city) {
      if (!city) return "";
      return city.id || city;
    },
    copyRegisteredAddress() {
      this.businessAddress.address = this.addressInfo.mailing_address;
      this.businessAddress.country_code = this.addressInfo.mailing_country;
      this.businessAddress.state_code = this.addressInfo.mailing_state;
      this.businessAddress.city_code = this.addressInfo.mailing_city;
      this.businessAddress.zip_code = this.addressInfo.mailing_postal_code;
      this.businessStateOptions = [...this.state_options];
      this.maling_city_options = [...this.city_options];
      this.haveBusCities = this.haveCities;
    },
    onSameAddressChange(isSame) {
      if (isSame) {
        this.copyRegisteredAddress();
      } else {
        this.businessAddress = {
          street_number: "",
          address: "",
          country_code: "",
          state_code: "",
          city_code: "",
          zip_code: "",
        };
        this.businessStateOptions = [];
        this.maling_city_options = [];
        this.haveBusCities = true;
      }
    },
    ValidateDateofIncop(value) {
      console.log("value", value);
      let presentDay = new Date().toJSON().slice(0, 10);
      console.log("presentDay", presentDay);
      if (value > presentDay) {
        this.doistate = true;
        this.EntityRules.DoiRules.push($.t("invalid_doi"));
      } else {
        this.doistate = false;
        this.EntityRules.DoiRules = [
          (v) => !!v || $.t("postalcode_placeholder_beneficary"),
        ];
      }
    },
    onChangeNumber(e) {
      this.isContactTouched = true;
      this.isValidNumber =
        e.isValid || this.hasValidPhoneNumber(this.addProfilePayload.phone_number);
    },
    validateContactNumber() {
      this.isContactTouched = true;
      this.isValidNumber = this.hasValidPhoneNumber(
        this.addProfilePayload.phone_number
      );
      return Boolean(this.addProfilePayload.phone_number) && this.isValidNumber;
    },
    onClickBack() {
      this.$emit("onClickBack");
    },

    async getentitydetails() {
      if (!this.$route.query.login_id || !this.$route.query.customer_id) return;
      this.loader = true;
      try {
        const response = await AgentService.getEntityinformation({
          login_id: this.$route.query.login_id,
          customer_id: this.$route.query.customer_id,
        });
        const entityInfo = response.data?.data?.[0];
        if (response.data.status_code == 200 && entityInfo) {
          this.is_update = true;
          this.combinedData = entityInfo;
          this.addProfilePayload = {
            entity_type: this.getDropdownValue(entityInfo.entity_type),
            business_name: entityInfo.business_name || "",
            registration_number: entityInfo.registration_number || "",
            business_email: entityInfo.business_email || "",
            nature_of_business: this.getDropdownValue(entityInfo.nature_of_business),
            is_mailing_address_same_as_business_address:
              entityInfo.is_mailing_address_same_as_business_address,
            website: entityInfo.website || "",
            dob: entityInfo.dob || null,
            source_of_fund_code: this.getDropdownValue(entityInfo.source_of_fund_code),
            salary_range: this.getDropdownValue(entityInfo.salary_range),
            phone_number: entityInfo.phone_number || "",
          };
          this.isValidNumber = this.hasValidPhoneNumber(
            this.addProfilePayload.phone_number
          );

          this.addressInfo = {
            mailing_address: entityInfo.mailing_address || "",
            mailing_country: this.getCountryValue(entityInfo.mailing_country),
            mailing_state: this.getStateValue(entityInfo.mailing_state),
            mailing_city: this.getCityValue(entityInfo.mailing_city),
            mailing_postal_code: entityInfo.mailing_postal_code || "",
          };
          this.businessAddress = {
            street_number: entityInfo.street_number || "",
            address: entityInfo.address || "",
            country_code: this.getCountryValue(entityInfo.country_code),
            state_code: this.getStateValue(entityInfo.state_code),
            city_code: this.getCityValue(entityInfo.city_code),
            zip_code: entityInfo.zip_code || "",
          };
          if (this.addProfilePayload.is_mailing_address_same_as_business_address) {
            this.copyRegisteredAddress();
          }
          await this.onChangeCounty(this.addressInfo.mailing_country);
          if (this.addressInfo.mailing_state) {
            await this.onChangeState(this.addressInfo.mailing_state);
          }
          if (!this.addProfilePayload.is_mailing_address_same_as_business_address) {
            await this.loadBusinessStates(this.businessAddress.country_code);
            if (this.businessAddress.state_code) {
              await this.onChangemailingState(this.businessAddress.state_code);
            }
          }
        } else {
          this.is_update = false;
        }
      } catch (error) {
        console.error(error);
        this.showAlertError("Something went wrong please try again later.");
      } finally {
        this.loader = false;
      }
    },

    async onClickNext() {
      const isContactValid = this.validateContactNumber();
      if (this.$refs.busEntity.validate() && isContactValid) {
        const combinedData = {
          ...this.addProfilePayload,
          ...this.addressInfo,
          ...this.businessAddress,
        };
        console.log("combinedData", combinedData);
        this.loader = true;
        try {
          const responseData = await AgentService.addEntityinformation(
            combinedData,
            { partner_id: sessionStorage.getItem("partner_id") }
          );
          if (responseData && responseData.data.status_code == 200) {
            const [entityInfo, loginInfo] = responseData.data.data;
            await this.$router.replace({
              name: "Customer Business",
              query: {
                login_id: loginInfo.login_id,
                customer_id: entityInfo.master_customer_id ?? entityInfo.customer_id,
              },
            });
            this.is_update = true;
            await this.getentitydetails();
            this.showAlertSuccess(responseData.data.message);
          } else {
            this.loader = false;
            this.showAlertError(responseData.data.message);
          }
        } catch (error) {
          console.error(error);
          this.loader = false;
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async updateEntityinfo() {
      const isContactValid = this.validateContactNumber();
      if (this.$refs.busEntity.validate() && isContactValid) {
        const combinedData = {
          ...this.addProfilePayload,
          ...this.addressInfo,
          ...this.businessAddress,
        };
        this.loader = true;
        try {
          const responseData = await AgentService.updateEntityinformation(
            combinedData,
            {
              login_id: this.$route.query.login_id,
              customer_id: this.$route.query.customer_id,
            }
          );
          if (responseData && responseData.data.status_code == 200) {
            this.loader = false;
            this.showAlertSuccess(responseData.data.message);
          } else {
            this.loader = false;
            this.showAlertError(responseData.data.message);
          }
        } catch (error) {
          console.error(error);
          this.loader = false;
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async getSourceFunds() {
      try {
        const responseData = await commonService.getparameterdropdowns("SOF");
        if (responseData.data.status_code === 200) {
          this.source_options = responseData.data.data.map((i) => {
            return { name: i.value, id: i.value_code };
          });
          if (
            this.is_update &&
            this.combinedData?.source_of_fund_code?.value_code
          ) {
            this.addProfilePayload.source_of_fund_code =
              this.combinedData.source_of_fund_code.value_code;
          }
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getAnnualTurnoverRanges() {
      try {
        const response = await commonService.getparameterdropdowns("ANR", "BUS");
        if (response.data.status_code === 200 && Array.isArray(response.data.data)) {
          this.annualTurnoverOptions = response.data.data.map((item) => ({
            name: item.value,
            id: item.value_code,
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getnatureOfBusiness() {
      try {
        const responseData = await commonService.getparameterdropdowns("NOB");
        if (responseData.data.status_code === 200) {
          this.natureofbusList = responseData.data.data.map((i) => {
            return { name: i.value, id: i.value_code };
          });
          if (
            this.is_update &&
            this.combinedData?.nature_of_business?.value_code
          ) {
            this.addProfilePayload.nature_of_business =
              this.combinedData.nature_of_business.value_code;
          }
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getPostalCodes() {
      try {
        const responseData = await commonService.getZipCodes();
        if (responseData.data.status_code === 200) {
          this.postalCodeslist = [...responseData.data.data];
        }
        console.log("postalCodes", responseData);
      } catch (err) {
        console.log(err);
      }
    },

    async getCountryList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return { name: i.country_name, id: i.iso_alpha3 };
          });
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },

    async onChangeCounty(iso3) {
      this.state_options = [];
      if (!iso3) return;
      try {
        const responseData = await commonService.getStatesList(iso3);
        if (this.addressInfo.mailing_country !== iso3) return;
        if (responseData.data.status_code === 200) {
          this.state_options = responseData.data.data.map((i) => {
            return {
              name: i.name,
              id: i.state_code,
            };
          });
          if (this.addProfilePayload.is_mailing_address_same_as_business_address) {
            this.copyRegisteredAddress();
          }
        }

        console.log("States", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    async loadBusinessStates(iso3) {
      this.businessStateOptions = [];
      if (!iso3) return;
      try {
        const response = await commonService.getStatesList(iso3);
        if (
          this.businessAddress.country_code !== iso3 ||
          this.addProfilePayload.is_mailing_address_same_as_business_address
        ) return;
        if (response.data.status_code === 200 && Array.isArray(response.data.data)) {
          this.businessStateOptions = response.data.data.map((state) => ({
            name: state.name,
            id: state.state_code,
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
    onChangeBusinessCountry(iso3) {
      this.businessAddress.state_code = "";
      this.businessAddress.city_code = "";
      this.businessAddress.zip_code = "";
      this.businessStateOptions = [];
      this.maling_city_options = [];
      this.haveBusCities = true;
      if (iso3) this.loadBusinessStates(iso3);
    },

    async onChangemailingState(state) {
      if (this.addProfilePayload.is_mailing_address_same_as_business_address) return;
      this.maling_city_options = [];
      this.businessAddress.city_code = "";
      this.haveBusCities = true;
      const country = this.businessAddress.country_code;
      if (!country || !state) return;
      try {
        const responseData = await commonService.getCitiesList(
          country,
          state
        );
        if (
          this.businessAddress.country_code !== country ||
          this.businessAddress.state_code !== state ||
          this.addProfilePayload.is_mailing_address_same_as_business_address
        ) return;
        if (responseData.data.status_code === 200 && Array.isArray(responseData.data.data)) {
          this.maling_city_options = responseData.data.data.map((i) => {
            return {
              val: i.id,
              txt: i.name,
            };
          });
          this.haveBusCities = this.maling_city_options.length > 0;
          const savedCity = this.combinedData.city_code;
          if (
            this.is_update && savedCity &&
            this.getCountryValue(this.combinedData.country_code) === country &&
            this.getStateValue(this.combinedData.state_code) === state
          ) {
            this.businessAddress.city_code = this.haveBusCities
              ? this.getCityValue(savedCity)
              : typeof savedCity === "string" ? savedCity : savedCity.name || "";
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async onChangeState(state) {
      this.city_options = [];
      this.addressInfo.mailing_city = "";
      this.haveCities = true;
      const country = this.addressInfo.mailing_country;
      if (!country || !state) return;
      try {
        const responseData = await commonService.getCitiesList(
          country,
          state
        );
        if (
          this.addressInfo.mailing_country !== country ||
          this.addressInfo.mailing_state !== state
        ) return;
        if (responseData.data.status_code === 200 && Array.isArray(responseData.data.data)) {
          this.city_options = responseData.data.data.map((i) => {
            return {
              val: i.id,
              txt: i.name,
            };
          });
          this.haveCities = this.city_options.length > 0;
          const savedCity = this.combinedData.mailing_city;
          if (
            this.is_update && savedCity &&
            this.getCountryValue(this.combinedData.mailing_country) === country &&
            this.getStateValue(this.combinedData.mailing_state) === state
          ) {
            this.addressInfo.mailing_city = this.haveCities
              ? this.getCityValue(savedCity)
              : typeof savedCity === "string" ? savedCity : savedCity.name || "";
          }
          if (this.addProfilePayload.is_mailing_address_same_as_business_address) {
            this.copyRegisteredAddress();
          }
        }
      } catch (e) {
        console.error(e);
      }
    },

    async getEntityType() {
      try {
        const responseData = await commonService.getparameterdropdowns("ETD");
        if (responseData.data.status_code === 200) {
          this.entityType_options = responseData.data.data.map((i) => {
            return { name: i.value, id: i.value_code };
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.invalid-feedback-name {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
</style>
